module.exports = __webpack_public_path__ + "static/media/worry-time-large@3x.cca49e7f.png";